(function() {
  
    var utils = require("./modules/utils.js");
    var timeline = require("./timeline.js");
    var globals = require("./modules/globals.js")
    var background = require("./modules/background.js")
    
    var AppData;
    
    module.exports = {
	init: init,
    }
    
    function init(appData) {	
	AppData = appData; //_interface;

//	setLang();
	prepSources();
    //parallax-video
	routie({
	    '': home,
	    '/intro/:page': intro,
	    '/explore': explore,
	    '/explore/timeline': openTimeline,
	    '/explore/event/:event': eventPage,
	    '/explore/person/:person': personPage,
	    '/explore/archive': archivePage,
	    '/explore/archive/:media': mediaPage,
	    '/about': aboutPage,
        '/biographies': bios,
/*	    '/credits': credits,
	    '/learn': goHome,
	    '/learn/:learn': learn,
	    '/listen': listen,
	    '/listen/discipline': goHome,
	    '/listen/tag': goHome,
	    '/listen/category/:category': list.bind(null, 'category'),
	    '/listen/category/:category/:story': story.bind(null, 'category'),
	    '/listen/tag/:tag': list.bind(null, 'tag'),
	    '/listen/tag/:tag/:story': story.bind(null, 'tag'),*/
	})
    }

    var timelineOn = false;

    function explore() {
	loadPage('explore', []);
    }

    function aboutPage() {
	loadPage('about', []);
    }

    function bios() {
        loadPage('bios', []);
    }
    
    function archivePage() {
/*	gridData = [];
	rowData =[];
	AppData.sources.forEach(function(el, i) {
	    
	    if(el.mediaType == 'text') {
		el.preview = 'text_1_W';
	    } else if (el.mediaType == 'audio') {
		el.preview = 'audio';
	    } else {
		el.preview = el.filename + '_S';
	    }
	    
	    rowData.push(el);
	    if((i+1)%4 == 0) {
		gridData.push({row:rowData})
		rowData = [];
	    }
	});
	gridData.push({row:rowData})*/

	gridData = makeGrid(AppData.sources, 4)
	
	loadPage('archive', {grid:gridData});
    }

    function makeGrid(lib, numRows) {
	gridData = [];
	rowData =[];
	lib.forEach(function(el, i) { 
	    if(el.mediaType === 'text' || el.mediaType === 'Texto') {
			el.preview = 'text_1_W';
	    } else if (el.mediaType.toLowerCase() === 'audio') {
			el.preview = 'audio';
	    } else {
			el.preview = el.filename + '_S';
	    }
	    
	    rowData.push(el);
	    if( (i+1) % numRows == 0) {
		gridData.push({row:rowData})
		rowData = [];
	    }
	});
	
	gridData.push({row:rowData})

	return gridData;
    }
    
    function mediaPage(id) {
	el = AppData.sources.filter(function(d) { return d.id == id; })[0];
	if(el.mediaType === 'text' || el.mediaType === 'Texto') {
	    el.ext = 'docx';
	} else if(el.mediaType.toLowerCase() === 'audio') {
	    el.ext = 'mp3';
	} else {
	    el.ext = 'pdf';
	}

	if(el.mediaType === 'text' || el.mediaType === 'Texto') {
	    el.background = 'text_1_W';
	} else if (el.mediaType.toLowerCase() === 'audio') {
	    el.background = 'audio';
	} else {
	    el.background = el.filename + '_L';
	}
	
	mediaData = {
	    media: el,
	}
	loadPage('media', mediaData);
    }
    
    function openTimeline() {
	if(timelineOn == false) {
	    console.log(window.innerHeight)
	    timeline.init(AppData, window.innerHeight)
	    timelineOn = true;
	}
	$("#main-view-container").fadeOut();
	$("#timeline-container, #settings-icon").fadeIn();
    }

    function home() {
	loadPage('landing', []);
    }

    function intro(page) {
	template = 'intro-'+page;
	loadPage(template, []);
    }

/*    function makePercent(el) {
	total = 0;
	el.forEach(function(e) {
	    total = total + e.value;
	})
	el.forEach(function(d) {
	    d.pc = Math.floor((d.value / total ) * 100)
	});
    }

    function checkList(val, library) {
	if(utils.checkExists(val, library, 'title') == true) {
	    ++library.filter(function(d) { return d.title == val;})[0].value
	} else {
	    library.push({title:val, value: 1, pc:null});
	}
    }
  */  
    function eventPage(id) {
	professions = [];
	genders = [];
	parties = [];
	residences = [];
	console.log(AppData)
	event = AppData.events.filter(function(d) { return d.id == id; })[0];
	date = event.startDate == '' ? event.date : event.startDate + " to " + event.endDate;
	attendees = AppData.links.filter(function(d) { return d.target == id; });
	attendees.forEach(function(el) {
	    person = AppData.people.filter(function(d) { return d.id == el.source; })[0];
	    el.person = person.name;
	    el.pid = person.id;
	    utils.checkList(person.proffesion, professions);
	    utils.checkList(person.gender, genders);
	    utils.checkList(person.residence, residences);
	    utils.checkList(person.party, parties);
	})
	utils.makePercent(professions);
	utils.makePercent(parties);
	utils.makePercent(genders);
	utils.makePercent(residences);
	coords = event.coord.split(',');
	args = {
	    name: event.eventName,
	    category: event.eventType,
	    location: event.location,
	    venue: event.venue,
	    date: date,
	    lat: coords[0],
	    lon: coords[1],
	    count: attendees.length,
	    attendees: attendees,
	    professions: professions,
	    parties: parties,
	    residences: residences,
	    genders: genders,
	    relMedia: event.relMedia.length > 0 ? makeGrid(event.relMedia, 3) : event.relMedia,
	}
	
	loadPage('event', args);
    }

    
    function personPage(id) {
	console.log(AppData)
	venues = [];
	locations = [];
	categories = [];
	
	person = AppData.people.filter(function(d) { return d.id == id;})[0];
//	console.log(person)
	protagonists = []
	person.datasets.forEach(function(d) {
	    protagonists.push(globals._data.protagonists[d])
	});
	console.log(id)
	events = AppData.links.filter(function(d) { return typeof d.source == 'string' ? d.source == id : d.source.id == id; })
	console.log(events)
	events.forEach(function(el) {
	    event = AppData.events.filter(function(d) { return typeof el.target == 'string' ? el.target == d.id : el.target.id == d.id; })[0]
	    date = event.startDate == '' ? event.date : event.startDate + " - " + event.endDate;
	    el.data = date;
	    el.title = event.eventName;
	    utils.checkList(event.venue, venues);
	    utils.checkList(event.location, locations);
	    utils.checkList(event.eventType, categories);
	});
	utils.makePercent(venues)
	utils.makePercent(locations)
	utils.makePercent(categories)
	utils.alphabetise(venues)
	utils.alphabetise(locations)
	utils.alphabetise(categories)
	
//	console.log(protagonists)
//	console.log(globals._data.protagonists)
	args = {
	    name: person.name,
	    protagonists: protagonists,
	    rel: person.relProtagonist,
	    bio: person.bioEn,
	    profession: person.proffesion,
	    residence: person.residence,
	    party: person.party,
	    image: person.image,
	    venues: venues,
	    locations: locations,
	    categories: categories,
	    events: events,
	    count: events.length,
	    relMedia: person.relMedia.length > 0 ? makeGrid(person.relMedia, 2) : person.relMedia,
	}
	loadPage('person', args)
    }

    function loadPage(template, args) {
	args.copy = AppData.copy
	console.log('args')
	console.log(args)
	if(template != 'person' && template != 'event') {
	    $("#timeline-container, #settings-icon").fadeOut();
	}
	background.stop();
	$("#background").remove();
	$("#main-view-container").fadeOut(function() {
	    $.ajax({
		url: 'templates/'+template+'.html',
		cache: false
		// dataType: "json"
	    }).done(function(data) {
		$("#main-view-container").html(Mustache.render(data, args));
		$("#main-view-container").fadeIn();
		$(".section-title").click(function() {
		    $(this).parent().toggleClass("expanded");
		})
		if(template == 'intro-0') {
            $(".intro-content.quote").fadeIn(3000);
         //   $("#intro-audio").play();
            setTimeout(function() {
                $(".intro-content.quote").fadeOut(function() {
                    $(".intro-content.quote h1").text("\""+globals.copy.quote1+"\"")
                    $(".intro-content.quote h3").text("José Ancan")
                    $(this).fadeIn();
                });
            }, 8000)
            setTimeout(function() {
		    	$(".intro-content.quote").fadeOut(2000, function() {
                 //   background.init('connect');
					setTimeout(function() {
                        $("#graph_container").fadeIn(3000, function() {
                            $("#bubbles_1").css("left", "200%");
                            $("#bubbles_2").css("left", "-100%");
                            audio = document.getElementById('intro-audio');
                            track = audio.textTracks[0];
                            console.log(track)
                            track.mode = "hidden";
                            //      add_transcript(track);
                            track.oncuechange = function() {
                                cue = this.activeCues[0];
                                console.log(cue)
                                $(".now-speaking-name").text(cue.text);
                            };
						});
                    },1000)
                    var f = 1;
//                    $("#graph_container").css("height", "100%").css("width", "100%").css("left", "0%").css("top", "0%");
	//				$("#graph_container, .intro_slide").css("left", "-200%");
			//		$("#base_img").css("left", "-10%");
	//				$(".intro_slide").css("left", "-30%");
                    setInterval(function() {
                    	$(".face.f"+String(f)).fadeIn(15000)
                    	f++
					}, 7000)
					var s = 1;
					setInterval(function() {
						$(".intro_slide.s"+String(s)).css('width', '100%');
						s++
					}, 3500)
					setTimeout(function() {
                        $(".intro-content.quote h1").text("\""+globals.copy.quote2+"\"")
                        $(".intro-content.quote h3").text("Chimamanda Ngozi Adichie")
                        $(".intro-content.quote").fadeIn(3000);
						$("#graph_container").fadeOut();
                        background.init('connect');
                        setTimeout(function() {
                        	$("#background, .intro-container, #intro-audio").fadeOut(function() {
                                routie("/explore")
                            })
						}, 14000)
					}, 99500)
                });
            }, 16000)
		} else if(template == 'intro-3') {
		    background.init('connect');	
		} /*else if(template == 'event') {
		coords = args.coords.split(',')
		utils.streetView(coords[0],coords[1])
	    }*/
	    });
	});
    }

/*    function setLang() {
    	domain = window.location.hostname;
	if(domain == 'interculturalconversations.com' || domain == 'localhost') {
	    globals.lang = 'en';
	} else if( domain == 'conversacionesinterculturales.com') {
	    globals.lang = 'es';
	}

	for(d in AppData.copy) {
	    AppData.copy[d] = AppData.copy[d][globals.lang];
	};
	globals.copy = AppData.copy;
	$(".header-brand-link").text("~  "+AppData.copy.siteTitle+"  ~")

    }
*/
    function prepSources() {
	AppData.sources.forEach(function(el) {
	    if(el.linkedTo != '') {
		linked = [];
		list = el.linkedTo.split(',');
		list.forEach(function(l) {
		    linked.push(AppData.sources.filter(function(d) { return d.id == l.trim(); })[0]);
		});
		el.linkedTo = linked;
	    }
	});
    }
    
})();
